export { default } from './styled';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/styles/esm/styled/index.js
// module id = 627
// module chunks = 0